import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import MainLayout from './MainLayout';

const ReportDetail = () => {
  const apiBaseUrl = process.env.REACT_APP_API_URL || 'https://pulse.marketersindemand.com';
  const { id } = useParams();
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${apiBaseUrl}/api/reports/${id}`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Failed to load report');
        setHtml(data.html || '<p>No HTML snapshot stored.</p>');
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  if (loading) return <MainLayout title="Report"><div style={{ padding: 24 }}>Loading...</div></MainLayout>;
  if (error) return <MainLayout title="Report"><div style={{ padding: 24, color: '#dc2626' }}>{error}</div></MainLayout>;

  return (
    <MainLayout title="Report">
      <div style={{ padding: 24 }}>
        <div style={{ marginBottom: 12 }}>
          <Link to="/reports">← Back to Reports</Link>
        </div>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </MainLayout>
  );
};

export default ReportDetail;


